var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loaded)?_c('div',{staticClass:"spinner-box text-center",attrs:{"role":"main"}},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner-border",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])
}]

export { render, staticRenderFns }